import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import { fetchWallets  } from '../api/userWalletApi';  // Import the fetchWallets function
import{rechargeWallet} from '../api/rechargeAdmin'
import * as XLSX from 'xlsx'; // Import the XLSX library
import '../../src/userWallet.css';




import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";

const Wallet = () => {
  const [wallets, setWallets] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);

  const [open, setOpen] = useState(false);
  const [rechargeAmount, setRechargeAmount] = useState("");
  const [mobileNumber , setNumber]=useState("")

  const navigate = useNavigate();

  const getWallets = async (page = 1) => {
    setLoading(true);
    try {
      const data = await fetchWallets(page, 10);  // Call the fetchWallets function from api.js
      console.log(data, "data")
      setWallets(data.data.wallet);
      setTotalPages(data.data.totalPages);
      setCurrentPage(data.data.currentPage);
    } catch (error) {
      console.error('Error fetching wallets:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getWallets(currentPage);
  }, [currentPage]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleBackClick = () => {
    navigate('/dashboard');
  };

  const convertToCSV = (data) => {
    const header = ["Phone Number", "Cumulated Recharge", "Cumulated Winning", "Cumulated Withdrawal", 'Total Tds Diduceted'];
    const rows = data.map(wallet => [
      wallet.user.mobile,
      wallet.cumulated_recharge,
      wallet.cumulated_winning,
      wallet.cumulated_widthraw,
      wallet.totaltdsDiducted

    ]);

    // Combine header and rows
    const csvContent = [
      header.join(","),  // Join header array into a single string
      ...rows.map(row => row.join(","))
    ].join("\n");  // Join all rows by a newline character

    return csvContent;
  };

  const downloadCSV = () => {
    const csvContent = convertToCSV(wallets);

    // Create a Blob from the CSV content
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

    // Create a link element to trigger the download
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);

    link.setAttribute("href", url);
    link.setAttribute("download", "wallet_data.csv");  // Set filename
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();  // Trigger the download
    document.body.removeChild(link);
  };

  // Function to download Excel
  const downloadExcel = () => {
    const header = ["Phone Number", "Cumulated Recharge", "Cumulated Winning", "Cumulated Withdrawal", 'Total Tds Diduceted'];
    const rows = wallets.map(wallet => ({
      "Phone Number": wallet.user.mobile,
      "Cumulated Recharge": wallet.cumulated_recharge,
      "Cumulated Winning": wallet.cumulated_winning,
      "Cumulated Withdrawal": wallet.cumulated_widthraw,
      'Total Tds Diduceted': wallet.totaltdsDiducted

    }));

    // Create a new workbook
    const ws = XLSX.utils.json_to_sheet(rows, { header }); // Create a sheet from JSON data
    const wb = XLSX.utils.book_new(); // Create a new workbook
    XLSX.utils.book_append_sheet(wb, ws, "Wallet Data"); // Append the sheet to the workbook

    // Write the workbook and trigger the download
    XLSX.writeFile(wb, "wallet_data.xlsx"); // This will download the Excel file
  };






  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setRechargeAmount("");
    setNumber("");
  };

  const addRecharge = async () => {
    try {
      const amount = parseFloat(rechargeAmount);
      const number = parseFloat(mobileNumber);


        if (isNaN(number) ) {
        alert("Please enter a Mobile Number");
        return;
      }

      if (isNaN(amount) || amount <= 0) {
        alert("Please enter a valid amount");
        return;
      }

      let payload = {
        amount : amount,
        phoneNumber:number

      }
      const data = await rechargeWallet(payload);
      if(data){
      alert("Recharge Successfully");

        getWallets(currentPage);
      }


      handleClose();
    } catch (err) {
      console.error("Recharge failed:", err);
      alert("Recharge failed, please try again.");
    }
  };










  return (
    <div>
      <h1>User Wallets</h1>
      <Button
        variant="contained"
        color="secondary"
        onClick={handleBackClick}
        sx={{ marginBottom: 2 }}
      >
        Back to Dashboard
      </Button>
      <Button
        variant="contained"
        color="primary"
        onClick={downloadCSV}
        sx={{ marginLeft: 10, marginBottom: 2 }}
      >
        Download CSV
      </Button>
      <Button
        variant="contained"
        color="primary"
        onClick={downloadExcel}
        sx={{ marginLeft: 10, marginBottom: 2 }}
      >
        Download Excel
      </Button>
      <Button
        variant="contained"
        color="primary"
        onClick={handleClickOpen}
        sx={{ marginLeft: 10, marginBottom: 2 }}
      >
        Add Recharge
      </Button>
      {loading && <p>Loading...</p>}

      <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
        <thead>
          <tr>
            <th>Phone Number</th>
            <th>Cumulated Recharge</th>
            <th>Cumulated Winning</th>
            <th>Cumulated Withdrawal</th>
            <th>Total Tds Diduceted</th>
          </tr>
        </thead>
        <tbody>
          {wallets.length > 0 ? (
            wallets.map((wallet, index) => (
              <tr key={index}>
                <td>{wallet.user.mobile}</td>
                <td>{wallet.cumulated_recharge}</td>
                <td>{wallet.cumulated_winning}</td>
                <td>{wallet.cumulated_widthraw}</td>
                <td>{wallet.totaltdsDiducted}</td>

              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4">No data available</td>
            </tr>
          )}
        </tbody>
      </table>

      <div>
        <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
          Previous
        </button>
        <span> Page {currentPage} of {totalPages} </span>
        <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
          Next
        </button>
      </div>

      <div>
        <Dialog open={open} onClose={handleClose}>
          <DialogTitle sx={{ fontWeight: 'bold' }}>Add Recharge</DialogTitle>
          <DialogContent>
             <TextField
              label="Enter Number"
              type="text"
              fullWidth
              value={mobileNumber}
              onChange={(e) => setNumber(e.target.value)}
              sx={{ mt: 2 }}
            />
            <TextField
              label="Enter Amount"
              type="number"
              fullWidth
              value={rechargeAmount}
              onChange={(e) => setRechargeAmount(e.target.value)}
              sx={{ mt: 2 }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="secondary">
              Cancel
            </Button>
            <Button onClick={addRecharge} color="primary" variant="contained">
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      </div>



    </div>
  );
};

export default Wallet;
